// Shared check for the Lifetime-installments plan's "payment failed, access
// locked" state (see subscription-service/scripts/installmentLifetime.js —
// lockForFailedInstallment). A locked coach has subscriptionDetails.subscription
// dropped to 0 same as a real cancellation, so every other tier-0 gate
// (SubscribeToBeVisibleBanner, SubscribeToBeVisiblePopup) would otherwise
// also fire with generic "start a free trial" copy that's wrong for someone
// who already paid part of this plan — this lets those gates suppress
// themselves in favor of InstallmentPaymentFailedBanner's specific copy.

export const INSTALLMENT_PLAN_ID = 'First-Mover-Lifetime-Installments-Monthly';

export function isInstallmentPaymentLocked(currentUser) {
  const metadata = currentUser && currentUser.attributes && currentUser.attributes.profile && currentUser.attributes.profile.metadata;
  if (!metadata) return false;
  const subscriptionDetails = metadata.subscriptionDetails;
  return !!(
    subscriptionDetails &&
    subscriptionDetails.planId === INSTALLMENT_PLAN_ID &&
    metadata.paymentStatus === 'failed'
  );
}
